export default __webpack_public_path__ + "static/media/consul.de1cf063.svg";